import { BrowserRouter as Router, Routes, Route  } from 'react-router-dom';
import { useQuery, gql } from '@apollo/client';
import React, { useContext, useState, useEffect } from "react";


import Home from './pages/Home';
import Home2 from './pages/Home2';
import SingIn from './pages/SingIn';
import SingUp from './pages/SingUp';
import AuthLayout from './components/AuthLayout';
import MainLayout from './components/MainLayout';

import Vari from './components/Vari';
import ThemeContext from './context/ThemeContext';
import { ThemeProvider } from './context/ThemeContext';
import { UserProvider } from './context/UserContext';
import UserContext from './context/UserContext';
import { YourComponentProvider } from './context/IdSeqContext2';
import Tailwind from "primereact/passthrough/tailwind";
import { usePassThrough } from "primereact/passthrough";
import { PrimeReactProvider } from "primereact/api";
import {IntlProvider, FormattedMessage, FormattedNumber} from 'react-intl'

import messages from './lang/LangGlb';


//theme
//import "primereact/resources/themes/tailwind-light/theme.css";     
    
//core
//import "primereact/resources/primereact.min.css";        





const App = () =>{

  const { users } = useContext(UserContext);

 
  //const locale = localStorage.getItem('lang');
  const locale = users.userLang || localStorage.getItem('lang') || 'en';

 
  //const locale = users.userLang || 'tr'; 
  console.log ("test:", locale);

  
 
  return (
    //Roting Auth take Vari
    <div>
      <IntlProvider locale={locale} messages={messages[locale]}>
        <PrimeReactProvider value={{ unstyled: true, pt: Tailwind }}>
          <YourComponentProvider>
            <ThemeProvider>
              <UserProvider>
                <Vari />
              </UserProvider>
            </ThemeProvider>
          </YourComponentProvider>
        </PrimeReactProvider>
      </IntlProvider>
    </div>
  );
};

export default App;





/*   <Router>
    <Routes>
      <Route path="/" element={<Home />} />    
      <Route path='Sing-Up' element={<SingUp />} />  
      <Route path='Sing-In' element={<SingIn />} />  
    </Routes>
   </Router>*/
